import "./AddonSuccessComponent.css"
import {useCms} from "../../../../context/CmsContext";
import CmsHelper, {PickProgramPageHelper} from "../../../Utilities/CmsHelpers";
import React from "react";
import {Button} from "@mui/material";

export default function AddonSuccessComponent({addon}) {
    const {pickProgramData} = useCms();

    if(!addon) return <></>;

    const pickAddons = PickProgramPageHelper.getPickAddons(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT))?.addons;
    const cmsData = PickProgramPageHelper.getAddon(pickAddons, addon?.addon?.skuORQuickCode)[0]

    return <>
        <div className={"congrats-success-addon-wraper"}>
            <span className={"congrats-success-addon-msg"}>
                {cmsData?.congratsSuccessMsg}
            </span>
            <div className={"congrats-success-addon-button-wrapper"}>
                <Button variant="contained"
                        color="primary"
                        href={addon.mlink}
                        target="_blank"
                >
                    {cmsData?.congratsSuccessCta}
                </Button>
            </div>
        </div>
    </>
}